export default [
  {
    path: '/admin/defines/countries',
    name: 'Countries',
    component: () => import('@/views/Admin/Defines/Countries/Index.vue'),
    meta: {
      pageTitle: 'Ülkeler',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/countries/add',
    name: 'CountryAdd',
    component: () => import('@/views/Admin/Defines/Countries/Add.vue'),
    meta: {
      pageTitle: 'Ülkeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/countries',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/countries/edit/:id',
    name: 'CountryEdit',
    component: () => import('@/views/Admin/Defines/Countries/Edit.vue'),
    meta: {
      pageTitle: 'Ülkeler',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/countries',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
